import { useEffect, useState } from "react";
import API from "../../services/api";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { TextField, MenuItem } from "@mui/material";
import { useLocation } from "react-router-dom";

function ServiceReport() {
    const loggedInUser =
        JSON.parse(localStorage.getItem("user"));

    const userRole =
        (loggedInUser?.role || "").toLowerCase();

    const loggedEmployeeId =
        loggedInUser?.empId || "";

    const loggedBranchId =
        loggedInUser?.branchId || "";

    const allBranches =
        (loggedInUser?.allBranches || "N") === "Y";

    const branchManager =
        (loggedInUser?.branchManager || "N") === "Y";

    const isAdmin =
        userRole === "admin";

    const isManager =
        userRole === "manager";

    const isUser =
        userRole === "user";
    // 🔹 Router
    const routerLocation = useLocation();

    // 🔹 Main Data
    const [data, setData] = useState([]);

    // 🔹 Date Filters
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    // 🔹 Filter Values
    const [employee, setEmployee] = useState("");
    const [location, setLocation] = useState("");
    const [organization, setOrganization] = useState("");
    const [customerType, setCustomerType] = useState("");

    const [serviceType, setServiceType] = useState("");     // ✅ ADD
    const [serviceStatus, setServiceStatus] = useState(""); // ✅ ADD
    const [status, setStatus] = useState("");               // ✅ ADD (Active / Closed)

    // 🔹 Dropdown Data
    const [employees, setEmployees] = useState([]);
    const [locations, setLocations] = useState([]);
    const [organizations, setOrganizations] = useState([]);

    const [serviceTypes, setServiceTypes] = useState([]);       // already there ✔
    const [serviceStatuses, setServiceStatuses] = useState([]); // already there ✔

    // 🔹 UI State
    const [search, setSearch] = useState("");

    useEffect(() => {

        // USER -> auto select own name
        if (isUser) {

            setEmployee(
                loggedEmployeeId || ""
            );
        }

    }, [isUser, loggedInUser]);
 
    useEffect(() => {

        loadDropdowns();

        const params = new URLSearchParams(routerLocation.search);

        const from = params.get("fromDate");
        const to = params.get("toDate");
        const emp = params.get("employee");
        const stat = params.get("status");
        const serviceStatus = params.get("serviceStatus");
        const serviceType = params.get("serviceType");

        if (from !== null && to !== null) {

            setFromDate(from);
            setToDate(to);
            setEmployee(emp || "");
            setStatus(stat || "");

            setServiceStatus(serviceStatus || "");
            setServiceType(serviceType || "");

            loadData(
                from,
                to,
                emp || "",
                stat || "",
                serviceStatus || "",
                serviceType || ""
            );

        } else if (!from && !to) {

            const today = new Date();
            const last7 = new Date();
            last7.setDate(today.getDate() - 7);

            const format = d => d.toISOString().split("T")[0];

            const fromDateVal = format(last7);
            const toDateVal = format(today);

            setFromDate(fromDateVal);
            setToDate(toDateVal);

            const employeeFilter =
                isUser
                    ? loggedEmployeeId
                    : "";

            loadData(
                fromDateVal,
                toDateVal,
                employeeFilter,
                "",
                "",
                ""
            );
        }

    }, [routerLocation.search]);

    const loadDropdowns = () => {
        API.get("/ServiceReport/dropdowns")
            .then(res => {

                let employeeData = res.data.employees || [];

                console.log("SERVICE REPORT EMPLOYEES:", employeeData);

                // ADMIN + AllBranches=Y
                if (isAdmin && allBranches) {

                    // show all
                }

                // ADMIN + AllBranches=N
                else if (isAdmin && !allBranches) {

                    employeeData = employeeData.filter(
                        e => String(e.branchId) === String(loggedBranchId)
                    );
                }

                // MANAGER + BranchManager=Y
                else if (isManager && branchManager) {

                    employeeData = employeeData.filter(
                        e => e.branchId === loggedBranchId
                    );
                }

                // MANAGER + BranchManager=N
                else if (isManager && !branchManager) {

                    employeeData = employeeData.filter(
                        e => String(e.id) === String(loggedEmployeeId)
                    );
                }

                // USER
                else if (isUser) {

                    employeeData = employeeData.filter(
                        e => String(e.id) === String(loggedEmployeeId)
                    );
                }

                setEmployees(employeeData);

                setLocations(res.data.locations || []);
                setOrganizations(res.data.organizations || []);
                setServiceTypes(res.data.serviceTypes || []);
                setServiceStatuses(res.data.serviceStatuses || []);
            })
            .catch(err => console.error("Dropdown error:", err));
    };

    const loadData = (
        f = fromDate,
        t = toDate,
        emp = employee,
        stat = status,
        serviceStat = serviceStatus,
        serviceTyp = serviceType,
        loc = location,
        org = organization,
        custType = customerType
    ) => {

        let query = [];

        // Dates
        if (f) query.push(`fromDate=${f}`);
        if (t) query.push(`toDate=${t}`);

        // 🔥 IMPORTANT: use PARAMS (not state)
        if (emp) query.push(`employee=${emp}`);
        if (loc) query.push(`location=${loc}`);
        if (org) query.push(`organization=${org}`);
        if (custType) query.push(`customerType=${custType}`);

        if (serviceTyp) query.push(`serviceType=${serviceTyp}`);
        if (serviceStat) query.push(`serviceStatus=${serviceStat}`);
        if (stat) query.push(`status=${stat}`);

        // Role information
        query.push(`role=${userRole}`);
        query.push(`branchId=${loggedBranchId}`);
        query.push(`branchManager=${branchManager ? "Y" : "N"}`);
        query.push(`empId=${loggedEmployeeId}`);
        query.push(`allBranches=${allBranches ? "Y" : "N"}`);

        if (minCharges) query.push(`minCharges=${minCharges}`);
        if (maxCharges) query.push(`maxCharges=${maxCharges}`);

        const url = `/ServiceReport${query.length ? "?" + query.join("&") : ""}`;

        console.log("API URL:", url);

        API.get(url)
            .then(res => setData(res.data.data))
            .catch(err => {
                console.error("Error loading service report:", err);
                setData([]);
            });
    };

    const exportToExcel = () => {

        const exportData = filteredData.map(x => ({
            Date: formatDate(x.visitDate),
            Employee: x.employeeName,
            Customer: x.customerName,
            Organization: x.organizationName,
            Machine: x.machineModel,
            "Serial No": x.serialNumber,
            "Service Type": x.serviceType,
            "Service Status": x.serviceStatus,
            "Service Charges": Number(x.serviceCharges || 0)
        }));

        // 👉 Add total row
        exportData.push({
            Date: "",
            Employee: "",
            Customer: "",
            Organization: "",
            Machine: "",
            "Serial No": "",
            "Service Type": "",
            "Service Status": "TOTAL",
            "Service Charges": totalCharges
        });

        const ws = XLSX.utils.json_to_sheet(exportData);

        // 👉 Auto column width (nice UX)
        const colWidths = [
            { wch: 12 }, { wch: 15 }, { wch: 18 },
            { wch: 20 }, { wch: 15 }, { wch: 18 },
            { wch: 15 }, { wch: 15 }, { wch: 15 }
        ];
        ws["!cols"] = colWidths;

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Service Report");

        const blob = new Blob([XLSX.write(wb, { bookType: "xlsx", type: "array" })]);
        saveAs(blob, "ServiceReport.xlsx");
    };

    const formatDate = (d) => {
        if (!d) return "";
        const dt = new Date(d);
        return `${dt.getDate()}/${dt.getMonth() + 1}/${dt.getFullYear()}`;
    };

    const handleLast7Days = () => {
        const today = new Date();
        const last7 = new Date();

        last7.setDate(today.getDate() - 7);

        const format = (d) => d.toLocaleDateString("en-CA");

        const from = format(last7);
        const to = format(today);

        setFromDate(from);
        setToDate(to);

        loadData(
            from,
            to,
            isUser ? loggedEmployeeId : "",
            status,
            serviceStatus,
            serviceType,
            location,
            organization,
            customerType
        );
    };

    const handleReset = () => {
        // reset filters
        setEmployee("");
        setLocation("");
        setOrganization("");
        setCustomerType("");

        setServiceType("");
        setServiceStatus("");

        setMinCharges("");
        setMaxCharges("");

        setSearch("");

        // reset dates to today
        const today = new Date().toLocaleDateString("en-CA");
        setFromDate(today);
        setToDate(today);

        // reload data
        loadData(
            today,
            today,
            isUser ? loggedEmployeeId : "",
            "",
            "",
            "",
            "",
            "",
            ""
        );
    };

    const handleFilter = () => {
        setPage(1);

        loadData(
            fromDate,
            toDate,
            employee,
            status,
            serviceStatus,
            serviceType,
            location,
            organization,
            customerType
        );
    };

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // filtering (if search exists)
    const filteredData = data

        // ACCESS CONTROL
        .filter(x => {

            const recordEmployeeId =
                x.employeeId !== null && x.employeeId !== undefined
                    ? String(x.employeeId)
                    : "";

            const loggedEmpId =
                loggedEmployeeId !== null && loggedEmployeeId !== undefined
                    ? String(loggedEmployeeId)
                    : "";

            const recordEmployeeName =
                (x.employeeName || "").trim().toLowerCase();

            // ADMIN + AllBranches=Y
            if (isAdmin && allBranches) {
                return true;
            }

            // ADMIN + AllBranches=N
            if (isAdmin && !allBranches) {
                return employees.some(e =>
                    String(e.id) === recordEmployeeId ||
                    (e.empName || "").trim().toLowerCase() === recordEmployeeName
                );
            }

            // MANAGER + BranchManager=Y
            if (isManager && branchManager) {
                return employees.some(e =>
                    String(e.id) === recordEmployeeId ||
                    (e.empName || "").trim().toLowerCase() === recordEmployeeName
                );
            }

            // MANAGER + BranchManager=N
            if (isManager && !branchManager) {
                return (
                    recordEmployeeId === loggedEmpId ||
                    employees.some(e =>
                        String(e.id) === loggedEmpId &&
                        (e.empName || "").trim().toLowerCase() === recordEmployeeName
                    )
                );
            }

            // USER
            if (isUser) {
                return (
                    recordEmployeeId === loggedEmpId ||
                    employees.some(e =>
                        String(e.id) === loggedEmpId &&
                        (e.empName || "").trim().toLowerCase() === recordEmployeeName
                    )
                );
            }

            return false;
        })

        // SEARCH FILTER
        .filter(x => {

            const term = (search || "").toLowerCase().trim();

            return (
                (x.employeeName || "").toLowerCase().includes(term) ||
                (x.customerName || "").toLowerCase().includes(term) ||
                (x.organizationName || "").toLowerCase().includes(term) ||
                (x.location || "").toLowerCase().includes(term) ||
                (x.customerType || "").toLowerCase().includes(term) ||
                (x.serviceType || "").toLowerCase().includes(term) ||
                (x.serviceStatus || "").toLowerCase().includes(term) ||
                (x.machineModel || "").toLowerCase().includes(term) ||
                (x.serialNumber || "").toLowerCase().includes(term) ||
                (x.complaint || "").toLowerCase().includes(term) ||
                (x.actionTaken || "").toLowerCase().includes(term) ||
                (x.spareUsed || "").toLowerCase().includes(term) ||
                (x.remarks || "").toLowerCase().includes(term) ||

                String(x.serviceCharges || "").includes(term) ||

                (x.visitDate
                    ? new Date(x.visitDate)
                        .toLocaleDateString()
                        .includes(term)
                    : false)
            );
        });
    const totalCharges = filteredData.reduce(
        (sum, x) => sum + (x.serviceCharges || 0),
        0
    );
    const totalRecords = filteredData.length;

    const completedJobs = filteredData.filter(x => x.serviceStatus === "Completed").length;

    const pendingJobs = filteredData.filter(x => x.serviceStatus === "Pending").length;

    const closedJobs = filteredData.filter(x => x.serviceStatus === "Closed").length;

    // pagination
    const indexOfLast = page * rowsPerPage;
    const indexOfFirst = indexOfLast - rowsPerPage;
    const currentData = filteredData.slice(indexOfFirst, indexOfLast);

    const totalPages = Math.ceil(filteredData.length / rowsPerPage);
   
    const [minCharges, setMinCharges] = useState("");
    const [maxCharges, setMaxCharges] = useState("");
    const highlightText = (text) => {
    const term = (search || "").trim().toLowerCase();
    if (!term) return text;

    const value = String(text || "");
    const index = value.toLowerCase().indexOf(term);

    if (index === -1) return value;

        return (
            <>
                {value.substring(0, index)}
                <span style={{
                    backgroundColor: "#ffeaa7",
                    fontWeight: "bold",
                    padding: "1px 2px",
                    borderRadius: "2px"
                }}>
                    {value.substring(index, index + term.length)}
                </span>
                {value.substring(index + term.length)}
            </>
        );
    };
    return (
        <div style={styles.container}>

            <div style={styles.header}>
                <h2>Service Report</h2>
            </div>

            {/* ROW 1 */}
            <div style={styles.row}>
                <TextField type="date" label="From" value={fromDate} onChange={e => setFromDate(e.target.value)} fullWidth size="small" InputLabelProps={{ shrink: true }} sx={styles.inputStyle} />
                <TextField type="date" label="To" value={toDate} onChange={e => setToDate(e.target.value)} fullWidth size="small" InputLabelProps={{ shrink: true }} sx={styles.inputStyle} />

                <TextField
                    select
                    label="Employee"
                    value={employee}
                    onChange={(e) => setEmployee(e.target.value)}
                    disabled={isUser}
                    sx={{
                        ...styles.inputStyle,
                        width: "370px"
                    }}
                >
                    {!isUser && (
                        <MenuItem value="" sx={styles.menuItem}>
                            All
                        </MenuItem>
                    )}

                    {[...employees]

                        .sort((a, b) =>
                            (a.empName || "").localeCompare(b.empName || "")
                        )

                        .map(emp => (

                            <MenuItem
                                key={emp.id}
                                value={emp.id}
                                sx={styles.menuItem}
                            >
                                <div style={{
                                    display: "flex",
                                    width: "100%",
                                    alignItems: "center"
                                }}>

                                    {/* EMPLOYEE */}
                                    <span style={{
                                        width: "160px",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis"
                                    }}>
                                        {emp.empName}
                                    </span>

                                    {/* BRANCH */}
                                    <span style={{
                                        width: "140px"
                                    }}>
                                        {"-> "} {emp.branchName}
                                    </span>

                                    {/* MOBILE */}
                                    <span>
                                        {"-> "} {emp.mobileNo}
                                    </span>

                                </div>
                            </MenuItem>

                        ))}
                </TextField>

                <TextField select label="Location" value={location} onChange={e => setLocation(e.target.value)} fullWidth size="small" sx={styles.inputStyle}>
                    <MenuItem value="" sx={styles.menuItem}>All</MenuItem>
                    {locations.map(l => <MenuItem key={l} value={l} sx={styles.menuItem}>{l}</MenuItem>)}
                </TextField>

                <TextField select label="Organization" value={organization} onChange={e => setOrganization(e.target.value)} fullWidth size="small" sx={styles.inputStyle}>
                    <MenuItem value="" sx={styles.menuItem}>All</MenuItem>
                    {organizations.map(o => <MenuItem key={o} value={o} sx={styles.menuItem}>{o}</MenuItem>)}
                </TextField>
            </div>

            {/* ROW 2 */}
            <div style={styles.filterRow}>

                <TextField
                    select
                    label="Customer Type"
                    value={customerType}
                    onChange={(e) => setCustomerType(e.target.value)}
                    size="small"
                    sx={styles.inputStyle}
                >
                    <MenuItem value="" sx={styles.menuItem}>All</MenuItem>
                    <MenuItem value="Banking" sx={styles.menuItem}>Banking</MenuItem>
                    <MenuItem value="Non Banking" sx={styles.menuItem}>Non Banking</MenuItem>
                    <MenuItem value="Institutional" sx={styles.menuItem}>Institutional</MenuItem>
                </TextField>

                <TextField
                    select
                    label="Service Type"
                    value={serviceType}
                    onChange={(e) => setServiceType(e.target.value)}
                    size="small"
                    sx={styles.inputStyle}
                >
                    <MenuItem value="" sx={styles.menuItem}>All</MenuItem>

                    {serviceTypes.map((type) => (
                        <MenuItem key={type} value={type} sx={styles.menuItem}>
                            {type}
                        </MenuItem>
                    ))}
                </TextField>

                <TextField
                    select
                    label="Service Status"
                    value={serviceStatus}
                    onChange={(e) => setServiceStatus(e.target.value)}
                    size="small"
                    sx={styles.inputStyle}
                >
                    <MenuItem value="" sx={styles.menuItem}>All</MenuItem>

                    {serviceStatuses.map((s) => (
                        <MenuItem key={s} value={s} sx={styles.menuItem}>
                            {s}
                        </MenuItem>
                    ))}
                </TextField>

                <TextField
                    label="Min Charges"
                    value={minCharges}
                    onChange={(e) => setMinCharges(e.target.value)}
                    size="small"
                    sx={styles.inputStyle}
                />

                <TextField
                    label="Max Charges"
                    value={maxCharges}
                    onChange={(e) => setMaxCharges(e.target.value)}
                    size="small"
                    sx={styles.inputStyle}
                />

            </div>

            {/* ACTION */}
            <div style={styles.row}>

                <button style={styles.filterBtn} onClick={handleFilter}>
                    Filter
                </button>

                <button style={styles.last7Btn} onClick={handleLast7Days}>
                    Last 7 Days
                </button>

                <button style={styles.resetBtn} onClick={handleReset}>
                    Reset
                </button>

                <div style={styles.searchBox}>
                    <span style={styles.searchIcon}>🔍</span>

                    <input
                        type="text"
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Escape") setSearch("");
                            if (e.key === "Enter") console.log("Enter pressed");
                        }}
                        style={styles.searchInput}
                    />

                    {search && (
                        <span
                            style={styles.clearIcon}
                            onClick={() => setSearch("")}
                            title="Clear"
                        >
                            ✕
                        </span>
                    )}
                </div>

                <button style={styles.exportBtn} onClick={exportToExcel}>
                    Export
                </button>

                <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px"
                }}>

                    {/* ROWS DROPDOWN BOX */}
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        background: "#f1f2f6",
                        padding: "6px 10px",
                        borderRadius: "6px",
                        border: "1px solid #dcdde1",
                        fontSize: "12px"
                    }}>
                        <span>Rows:</span>

                        <select
                            value={rowsPerPage}
                            onChange={(e) => {
                                setRowsPerPage(Number(e.target.value));
                                setPage(1);
                            }}
                            style={styles.select}
                        >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                        </select>
                    </div>
                </div>

            </div>
            <div style={{
                display: "flex",
                gap: "10px",
                marginBottom: "10px"
            }}>

                {/* TOTAL RECORDS */}
                <div style={{
                    ...styles.card,
                    flex: 1,
                    background: "#e3f2fd",
                    border: "1px solid #1e90ff"
                }}>
                    <div>Total Records</div>
                    <strong>{totalRecords}</strong>
                </div>

                {/* TOTAL REVENUE */}
                <div style={{
                    ...styles.card,
                    flex: 1,
                    background: "#eafaf1",
                    border: "1px solid #2ed573"
                }}>
                    <div>Total Revenue</div>
                    <strong>
                        ₹ {totalCharges.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                    </strong>
                </div>

                {/* PENDING */}
                <div style={{
                    ...styles.card,
                    flex: 1,
                    background: "#ffeaea",
                    border: "1px solid #ff4757"
                }}>
                    <div>Pending Jobs</div>
                    <strong>{pendingJobs}</strong>
                </div>

                {/* COMPLETED */}
                <div style={{
                    ...styles.card,
                    flex: 1,
                    background: "#e8f5e9",
                    border: "1px solid #2ecc71"
                }}>
                    <div>Completed Jobs</div>
                    <strong>{completedJobs}</strong>
                </div>

                {/* ✅ CLOSED (NEW) */}
                <div style={{
                    ...styles.card,
                    flex: 1,
                    background: "#f3f4f6",
                    border: "1px solid #57606f"
                }}>
                    <div>Closed Jobs</div>
                    <strong>{closedJobs}</strong>
                </div>

            </div>

            {/* TABLE */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.tableHeader}>
                        <tr>
                            <th style={styles.th}>Date</th>
                            <th style={styles.th}>Employee</th>
                            <th style={styles.th}>Customer</th>
                            <th style={styles.th}>Organization</th>
                            <th style={styles.th}>Machine</th>
                            <th style={styles.th}>Serial No</th>
                            <th style={styles.th}>Service Type</th>
                            <th style={styles.th}>Service Status</th>
                            <th style={styles.th}>Charges</th>
                        </tr>
                    </thead>

                    <tbody>
                        {currentData.length === 0 ? (
                            <tr>
                                <td colSpan="9" style={{ textAlign: "center" }}>
                                    No records
                                </td>
                            </tr>
                        ) : currentData.map(x => (
                            <tr key={x.id}>
                                <td style={styles.td}>{formatDate(x.visitDate)}</td>

                                <td style={styles.td}>{highlightText(x.employeeName)}</td>
                                <td style={styles.td}>{highlightText(x.customerName)}</td>
                                <td style={styles.td}>{highlightText(x.organizationName)}</td>
                                <td style={styles.td}>{highlightText(x.machineModel)}</td>
                                <td style={styles.td}>{highlightText(x.serialNumber)}</td>
                                <td style={styles.td}>{highlightText(x.serviceType)}</td>
                                <td style={styles.td}>{highlightText(x.serviceStatus)}</td>

                                <td style={styles.td}>
                                    ₹ {highlightText(
                                        Number(x.serviceCharges || 0).toLocaleString("en-IN", {
                                            minimumFractionDigits: 2
                                        })
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div style={{ marginTop: "10px", display: "flex", justifyContent: "center", gap: "10px" }}>
                    <button disabled={page === 1} onClick={() => setPage(page - 1)}>
                        Prev
                    </button>

                    <span>
                        Page {page} of {totalPages}
                    </span>

                    <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>
                        Next
                    </button>
                </div>
                {/* ✅ ADD HERE */}
                <div style={{
                    marginTop: "10px",
                    textAlign: "right",
                    fontWeight: "bold",
                    paddingRight: "10px"
                }}>
                    Total Records: {filteredData.length} &nbsp; | &nbsp;
                    ₹ {totalCharges.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                </div>
            </div>

        </div>
    );
}

const styles = {
    container: { padding: 5, background: "#f1f2f6", fontFamily: "Verdana", fontSize: "12px" },

    header: {
        background: "#2f3542",
        color: "#fff",
        padding: "6px",
        borderRadius: "6px",
        marginBottom: "10px"
    },

    row: {
        display: "flex",
        gap: "10px",
        flexWrap: "nowrap",
        alignItems: "center",
        marginBottom: "8px"
    },

    row2: {
        display: "flex",
        gap: "10px",
        flexWrap: "nowrap",
        alignItems: "center",
        marginBottom: "8px"
    },

    filterRow: {
        gap: "10px",
        flexWrap: "wrap",
        alignItems: "center",
        marginBottom: "8px"
    },

    menuItem: {
        fontFamily: "Verdana",
        fontSize: "12px"
    },

    // ✅ INPUT STYLE
    inputStyle: {
        width: "180px",

        "& .MuiOutlinedInput-root": {
            height: "32px",
            fontSize: "12px",
            fontFamily: "Verdana"
        },

        "& .MuiInputBase-input": {
            padding: "8px 10px",
            fontFamily: "Verdana",
            fontSize: "12px"
        },

        "& .MuiInputLabel-root": {
            fontFamily: "Verdana",
            fontSize: "12px"
        }
    },

    // ✅ BUTTON STYLES (CORRECT PLACE)
    filterBtn: {
        background: "#2ed573",
        border: "none",
        padding: "6px 12px",
        color: "#fff",
        borderRadius: "4px",
        cursor: "pointer",
        fontFamily: "Verdana",
        fontSize: "12px"
    },

    last7Btn: {
        background: "#2ed573",
        border: "none",
        padding: "6px 12px",
        color: "#fff",
        borderRadius: "4px",
        cursor: "pointer",
        fontFamily: "Verdana",
        fontSize: "12px"
    },

    resetBtn: {
        background: "#ff4757",
        border: "none",
        padding: "6px 12px",
        color: "#fff",
        borderRadius: "4px",
        cursor: "pointer",
        fontFamily: "Verdana",
        fontSize: "12px"
    },

    exportBtn: {
        background: "#1e90ff",
        border: "none",
        padding: "6px 12px",
        color: "#fff",
        borderRadius: "4px",
        cursor: "pointer",
        fontFamily: "Verdana",
        fontSize: "12px"
    },

    // OPTIONAL (for search & dropdown)
    search: {
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        fontFamily: "Verdana",
        fontSize: "12px"
    },

    select: {
        padding: "5px",
        fontFamily: "Verdana",
        fontSize: "12px",
        borderRadius: "4px"
    },

    tableWrapper: { width: "100%", overflowX: "auto" },
    table: { width: "100%", borderCollapse: "collapse" },

    tableHeader: { background: "#57606f", color: "#fff" },

    th: { border: "1px solid #ccc", padding: "8px" },
    td: {
        border: "1px solid #ddd",
        padding: "8px",
        whiteSpace: "nowrap"   // 🔥 THIS FIXES BREAKING
    },
    card: {
        flex: 1,
        background: "#ffffff",
        padding: "10px",
        borderRadius: "6px",
        boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
        textAlign: "center",
        fontSize: "12px"
    },
    searchBox: {
        display: "flex",
        alignItems: "center",
        border: "1px solid #ccc",
        borderRadius: "6px",
        padding: "4px 8px",
        background: "#fff",
        width: "180px"
    },

    searchIcon: {
        marginRight: "6px",
        fontSize: "14px",
        color: "#888"
    },

    searchInput: {
        border: "none",
        outline: "none",
        fontFamily: "Verdana",
        fontSize: "12px",
        width: "100%",
        background: "transparent"
    },

    clearIcon: {
        marginLeft: "6px",
        cursor: "pointer",
        fontSize: "12px",
        color: "#999"
    },


};
export default ServiceReport;